import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    Typography,
    TextField,
    FormControl,
    Switch
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { fetchAuth, clearErrors } from "../../store/slice/userSlice"
import { useNavigate } from "react-router-dom";

const AuthForm = ({ action, open, onClose }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { error, isLoading } = useSelector(state => state.user);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [check, setCheck] = useState(false);
    

    // Проверка email с помощью регулярки
    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    // Проверка, можно ли включить кнопку
    const checkDisabled = () => {
        if (!login.trim() || !password.trim()) return true;

        if (action === 'reg') {
            if (!email.trim() || !isValidEmail(email)) return true;
            if (!check) return true; // нужно согласие
        }

        return false;
    }

    const handleClose = () => {
        setLogin('')
        setPassword('')
        setEmail('')
        setCheck(false)
        onClose()
        dispatch(clearErrors())
    }

    const handleSubmit = async () => {
        // вызываем dispatch и ждем результата
        const result = await dispatch(fetchAuth({
            action,
            login,
            password,
            email
        }));

        // Если успех, перевести на /account
        if (fetchAuth.fulfilled.match(result)) {
            navigate('/account');
            handleClose(); // закрыть модальное окно
        }
    };

    return (
        <>
            <Dialog className="regForm" onClose={handleClose} open={open}>
                <DialogTitle sx={{ textAlign: 'center', paddingTop: "30px" }} >
                    {action === 'login' ? 'Вход' : 'Регистрация'}
                </DialogTitle>
                <Box
                    display="flex"
                    flexDirection="column"
                    gap={2}
                    p={2}
                    mb={2}
                    minWidth="350px"
                >
                    {error && <Typography align="center" color='error'>{error}</Typography>}

                    <FormControl fullWidth sx={{ maxWidth: 350 }}>
                        <TextField
                            label="Логин"
                            variant="outlined"
                            value={login}
                            onChange={(e) => setLogin(e.target.value)}
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{ maxWidth: 350 }}>
                        <TextField
                            label="Пароль"
                            variant="outlined"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormControl>

                    {action === "reg" &&
                        <>
                            <FormControl fullWidth sx={{ maxWidth: 350 }}>
                                <TextField
                                    label="E-mail"
                                    variant="outlined"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    error={email && !isValidEmail(email)}
                                    helperText={email && !isValidEmail(email) ? 'Некорректный email' : ''}
                                />
                            </FormControl>
                            <Box
                                display="flex"
                                gap={2}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Switch
                                    checked={check}
                                    onChange={(event) => setCheck(event.target.checked)}
                                />
                                <Typography variant="body2">
                                    Я принимаю <Link to="/term-and-conditions">Условия пользователя</Link>
                                </Typography>
                            </Box>
                        </>
                    }

                    <Box display="flex" justifyContent="center">
                        <Button
                            disabled={checkDisabled()}
                            variant="contained"
                            onClick={handleSubmit}
                            
                        >
                            { isLoading ?  <CircularProgress size="30px" sx={{color:"#fff"}} aria-label="Loading…" /> : (action === 'login' ? 'Вход' : 'Регистрация')}
                        </Button>
                    </Box>

                </Box>
            </Dialog>
        </>
    )
}

export default AuthForm;